// extracted by mini-css-extract-plugin
export var colorSquare = "_nw-0";
export var container = "_nw-h";
export var danger = "_nw-5";
export var lightPink = "_nw-8";
export var neutralBlue = "_nw-7";
export var neutralYellow = "_nw-6";
export var normal = "_nw-1";
export var primary = "_nw-2";
export var primaryLight = "_nw-3";
export var selected = "_nw-i";
export var solidBlack = "_nw-g";
export var solidGreen = "_nw-b";
export var solidLightBlue = "_nw-d";
export var solidNavy = "_nw-c";
export var solidOrange = "_nw-f";
export var solidPink = "_nw-e";
export var solidRed = "_nw-9";
export var solidYellow = "_nw-a";
export var success = "_nw-4";